import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import NewUserDashboard from '../pages/NewUserDashboard';
import NewAdminDashboard from '../pages/NewAdminDashboard';

const DashboardRouter: React.FC = () => {
  const { user } = useAuth();

  // Show admin dashboard for admins, user dashboard for regular users
  return user?.role === 'admin' ? <NewAdminDashboard /> : <NewUserDashboard />;
};

export default DashboardRouter;